<div provide-parent-form *ngIf="entity">
	<bb-form-element [form]="form" [label]="'ENABLE_AUTOMATED_SYNCING' | translate">
		<bb-check [(ngModel)]="entity.automatedSync" (ngModelChange)="automatedSyncChanged($event)" [ngModelOptions]="{standalone: true}"></bb-check>
	</bb-form-element>
	<p [innerHtml]="'SOCIAL_SELECTION_DESCRIPTION_ONLY_VIDEOS' | translate" class="grey"></p>

	<div [ngClass]="{'disabled': !entity.automatedSync}">
		<h3>{{ 'AUTOMATED_SYNCING_CONFIG' | translate }}</h3>

		<div class="filter-type-buttons">
			<bb-button [active]="entity.filterType === 'filters'" [disabled]="!entity.automatedSync" (click)="onFilterClick('filters')">
				<i class="fa fa-filter"></i> {{ 'FILTERS' | translate }}
			</bb-button>
			<bb-button [active]="entity.filterType === 'solr'" [disabled]="!entity.automatedSync" (click)="onFilterClick('solr')">
				<i class="fa fa-terminal"></i> {{ 'SOLR_QUERY' | translate }}
			</bb-button>
			<bb-button [active]="entity.filterType === 'cliplist'" [disabled]="!entity.automatedSync" (click)="onFilterClick('cliplist')">
				<i class="fa fa-list"></i> {{ 'PLAYLIST' | translate }}
			</bb-button>
		</div>

		<ng-container *ngIf="entity.filterType === 'filters'">
			<p *ngIf="!entity.cliplist?.filters?.length">
					{{ 'NO_FILTERS_SELECTED' | translate }}
			</p>	
			<bb-filter-set name="playlist-filters" [filterConfig]="filterConfig" [ngModel]="entity.cliplist?.filters" (ngModelChange)="filterChanged.next($event)"></bb-filter-set>
		</ng-container>

		<ng-container *ngIf="entity.filterType === 'solr'">
			<p [innerHTML]="'PLAYLIST_SWITCH_WARNING' | translate"></p>
			<textarea *ngIf="!docText" class="query-area" type="text" [ngModel]="entity.cliplist?.query" name="playlist-query" (ngModelChange)="queryChanged.next($event)"></textarea>
		</ng-container>

		<ng-container *ngIf="entity.filterType === 'cliplist'">
			<bb-form-element [label]="'PLAYLIST' | translate">
				<bb-entity-selector
					[(ngModel)]="cliplist"
					entityType="cliplist"
					(ngModelChange)="onSelectedCliplist($event)"
					[ngModelOptions]="{standalone: true}"
				></bb-entity-selector>
			</bb-form-element>
		</ng-container>

		<ng-container *ngIf="entity.filterType !== 'cliplist'">
			<bb-form-element [form]="form" label="{{ 'LIMIT_RESULTS' | translate}}">
				<bb-check [ngModel]="entity.cliplist?.limit >= 0" name="playlist-hasLimit" (ngModelChange)="onUseLimitChange($event)"></bb-check>
			</bb-form-element>

			<bb-form-element *ngIf="entity.cliplist?.limit >= 0" [form]="form" [label]="'LIMIT_TO' | translate">
				<input class="limit" type="number" [ngModel]="entity.cliplist?.limit" name="playlist-limit" (ngModelChange)="limitChanged.next($event)"/>
				<span class="text-only">{{ 'CLIPS' | translate }}</span>
			</bb-form-element>

			<bb-form-element [form]="form" [label]="'SORT_RESULTS_BY' | translate">
				<bb-select
					[(ngModel)]="filterSort.sortProperty"
					(change)="onSortChange()"
					[options]="sortPropertyOptions"
					name="filterSort-property">
				</bb-select>
				<bb-select
					[(ngModel)]="filterSort.sortDirection"
					(change)="onSortChange()"
					name="filterSort-direction">
					<option value="asc">{{ 'ASCENDING' | translate | lowercase }}</option>
					<option value="desc">{{ 'DESCENDING' | translate | lowercase }}</option>
				</bb-select>
			</bb-form-element>
			
			<ng-container *ngIf="entity.filterType === 'solr'">
				<bb-solr-query-documentation></bb-solr-query-documentation>
			</ng-container>
		</ng-container>

	</div>

</div>
